import script from "./insurance-aggregation.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-aggregation.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-aggregation.vue?vue&type=style&index=0&id=1927da61&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1927da61"]])

export default __exports__